import { css } from '@emotion/react'
import styled from '@emotion/styled'
import React, {
  ChangeEventHandler,
  FocusEventHandler,
  forwardRef,
  memo,
} from 'react'

import { Option, Props as OptionProps } from './Option'

export interface Props {
  disabledFirst?: string
  name: string
  error?: boolean
  isDirty?: boolean
  options: OptionProps[]
  required?: boolean
  size?: 'M' | 'L'
  defaultValue?: string
  onBlur: FocusEventHandler<HTMLSelectElement>
  onChange?: ChangeEventHandler<HTMLSelectElement>
  onFocus?: FocusEventHandler<HTMLSelectElement>
}
export const Select = memo(
  forwardRef<HTMLSelectElement, Props>(function Select(
    {
      disabledFirst,
      name,
      error = false,
      isDirty = false,
      options,
      required,
      size = 'M',
      defaultValue,
      onBlur,
      onChange,
      onFocus,
    },
    ref,
  ) {
    return (
      <Container
        ref={ref}
        error={error}
        className={`type-${size}`}
        isDirty={isDirty}
        name={name}
        required={required}
        defaultValue={defaultValue}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
      >
        {disabledFirst ? <Option value={disabledFirst} disabled /> : null}
        {options.map((item, index) => (
          <Option key={index} {...item} />
        ))}
      </Container>
    )
  }),
)

Select.displayName = 'Select'

const Container = styled.select<ContainerProps>`
  width: 100%;
  height: 3rem;
  font-family: ${({ theme }) => theme.fontFamily.paragraph};
  font-size: 0.9375rem;
  background-image: url('/chevron-down.svg');
  background-position: calc(100% - 1rem) center;
  background-repeat: no-repeat;
  color: ${({ theme }) => theme.colors.variants.neutralDark1};
  cursor: pointer;
  padding: 0 1rem;

  ${({ theme, error }) => {
    return css`
      border-bottom: 1px solid
        ${error ? theme.colors.variants.dangerLight1 : '#EDF4F1'};
      background-color: rgba(237, 244, 241, 0.5);
    `
  }}
`

interface ContainerProps {
  error: boolean
  isDirty: boolean
}
